export default function () {
  return {
    loading: false,
    paymentData: null,
    paymentHtml: '',
    status: false,
  }
}
